/**
 * Built-in background presets for the Worship Presenter.
 * Mirrors `BACKGROUND_PRESETS` in `/app/backend/routes/worship.py`
 * so the picker works even if the backgrounds endpoint hasn't been hit.
 */
export const PRESET_BACKGROUNDS = [
  {
    key: 'aurora',
    label: 'Aurora',
    bg_type: 'gradient',
    bg_value: 'linear-gradient(135deg, #1e1b4b 0%, #4c1d95 50%, #0f172a 100%)',
    accent_color: '#a78bfa',
    text_color: '#f8fafc',
  },
  {
    key: 'sunrise',
    label: 'Sunrise',
    bg_type: 'gradient',
    bg_value: 'linear-gradient(135deg, #7c2d12 0%, #b45309 50%, #4c1d95 100%)',
    accent_color: '#fbbf24',
    text_color: '#f8fafc',
  },
  {
    key: 'ocean',
    label: 'Ocean',
    bg_type: 'gradient',
    bg_value: 'linear-gradient(135deg, #0c4a6e 0%, #0369a1 50%, #082f49 100%)',
    accent_color: '#38bdf8',
    text_color: '#f8fafc',
  },
  {
    key: 'forest',
    label: 'Forest',
    bg_type: 'gradient',
    bg_value: 'linear-gradient(135deg, #14532d 0%, #166534 50%, #052e16 100%)',
    accent_color: '#4ade80',
    text_color: '#f8fafc',
  },
  {
    key: 'stage',
    label: 'Stage Black',
    bg_type: 'color',
    bg_value: '#000000',
    accent_color: '#f43f5e',
    text_color: '#f8fafc',
  },
  {
    key: 'chapel',
    label: 'Chapel White',
    bg_type: 'color',
    bg_value: '#f8fafc',
    accent_color: '#4c1d95',
    text_color: '#0f172a',
  },
  {
    key: 'grain',
    label: 'Grain Noir',
    bg_type: 'gradient',
    bg_value: 'radial-gradient(circle at 30% 20%, #292524 0%, #0c0a09 60%, #000000 100%)',
    accent_color: '#fde68a',
    text_color: '#f8fafc',
  },
];

export const DEFAULT_THEME = {
  preset: 'aurora',
  bg_type: 'gradient',
  bg_value: 'linear-gradient(135deg, #1e1b4b 0%, #4c1d95 50%, #0f172a 100%)',
  overlay: 0.25,
  blur: 0,
  font_family: 'serif',
  text_color: '#f8fafc',
  accent_color: '#a78bfa',
  text_align: 'center',
};

/** Build the outer CSS style object for a slide, honouring the theme + optional block override. */
export function buildSlideStyle(theme, override) {
  const t = { ...DEFAULT_THEME, ...(theme || {}), ...(override || {}) };
  const style = {
    color: t.text_color || '#f8fafc',
    fontFamily:
      t.font_family === 'sans' ? 'ui-sans-serif, system-ui, sans-serif'
        : t.font_family === 'display' ? '"Playfair Display", "Georgia", serif'
        : t.font_family === 'mono' ? 'ui-monospace, "SFMono-Regular", monospace'
        : '"Georgia", "Times New Roman", serif',
    textAlign: t.text_align || 'center',
    position: 'relative',
    overflow: 'hidden',
  };
  if (t.bg_type === 'gradient' || t.bg_type === 'color') {
    style.background = t.bg_value;
  } else {
    // image / video handled by an inner layer for blur support
    style.background = '#000';
  }
  return { style, resolved: t };
}
